export const firebaseConfig = {
    apiKey: "AIzaSyBpS5HbrTWKzhEYULSnCxe7p9ob28XECSM",
    authDomain: "coreachord.firebaseapp.com",
    projectId: "coreachord",
    storageBucket: "coreachord.appspot.com",
    messagingSenderId: "779241976052",
    appId: "1:779241976052:web:16d34cb5bfc20a8f6beea1",
    measurementId: "G-GMSM8P1Q26"
  };

